/**
 * @generated SignedSource<<52f22cfb18abb2462ec19d1b389ab30f>>
 * @relayHash 701c47ab92ba720656167a68651cabf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 945e7480c8024c5838976cd3c3e16f1bc80c56650f328afd46dd6931baf9bf0f

import type { ConcreteRequest } from 'relay-runtime';
export type PopularFeedWithTimeGranularityStorageSnippetsQuery$variables = {
  after?: string | null;
  first?: number | null;
  isRovoLLMEnabled?: boolean | null;
  timeGranularity?: string | null;
};
export type PopularFeedWithTimeGranularityStorageSnippetsQuery$data = {
  readonly popularFeed: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly aiProperty?: {
          readonly createdAt: string;
          readonly errorMessage: string | null;
          readonly objectData: string | null;
        } | null;
        readonly contentProperties: {
          readonly latest: {
            readonly generatedBy: string | null;
          } | null;
        } | null;
        readonly emoji: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly excerpt: string;
        readonly history: {
          readonly createdBy: {
            readonly accountId?: string | null;
            readonly displayName: string | null;
            readonly profilePicture: {
              readonly path: string;
            } | null;
            readonly type: string | null;
          } | null;
          readonly createdDate: string | null;
          readonly ownedBy: {
            readonly accountId?: string | null;
            readonly displayName: string | null;
            readonly profilePicture: {
              readonly path: string;
            } | null;
            readonly type: string | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly name: string | null;
          } | null> | null;
        } | null;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly metadata: {
          readonly comments: {
            readonly commentsCount: number | null;
          } | null;
          readonly currentuser: {
            readonly favourited: {
              readonly isFavourite: boolean | null;
            } | null;
          } | null;
          readonly lastModifiedDate: string | null;
        };
        readonly space: {
          readonly alias: string | null;
          readonly id: string | null;
          readonly key: string | null;
          readonly name: string | null;
        } | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
        readonly version: {
          readonly friendlyWhen: string | null;
        } | null;
      } | null;
    }>;
    readonly pageInfo: {
      readonly endCursor: string;
      readonly hasNextPage: boolean;
    };
  } | null;
};
export type PopularFeedWithTimeGranularityStorageSnippetsQuery = {
  response: PopularFeedWithTimeGranularityStorageSnippetsQuery$data;
  variables: PopularFeedWithTimeGranularityStorageSnippetsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isRovoLLMEnabled"
},
v3 = {
  "defaultValue": "default",
  "kind": "LocalArgument",
  "name": "timeGranularity"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "timeGranularity",
    "variableName": "timeGranularity"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "title"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = {
  "kind": "ScalarField",
  "name": "subType"
},
v9 = {
  "alias": "emoji",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v10 = {
  "condition": "isRovoLLMEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "entryPoint",
          "value": "CONFLUENCE_HOME_POPULAR_FEED"
        }
      ],
      "concreteType": "ConfluenceContentAISummaryResponse",
      "kind": "LinkedField",
      "name": "aiProperty",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "errorMessage"
        },
        {
          "kind": "ScalarField",
          "name": "createdAt"
        },
        {
          "kind": "ScalarField",
          "name": "objectData"
        }
      ],
      "storageKey": "aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\")"
    }
  ]
},
v11 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v12 = {
  "args": [
    {
      "kind": "Literal",
      "name": "length",
      "value": 350
    }
  ],
  "kind": "ScalarField",
  "name": "excerpt",
  "storageKey": "excerpt(length:350)"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v15 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    (v13/*: any*/)
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v17 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v18 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v19 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "KnownUser"
},
v21 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "UnknownUser"
},
v22 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "commentsCount"
        }
      ]
    },
    {
      "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
      "kind": "LinkedField",
      "name": "currentuser",
      "plural": false,
      "selections": [
        {
          "concreteType": "FavouritedSummary",
          "kind": "LinkedField",
          "name": "favourited",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavourite"
            }
          ]
        }
      ]
    }
  ]
},
v23 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "friendlyWhen"
    }
  ]
},
v24 = {
  "concreteType": "FeedPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedPopularFeed",
        "kind": "LinkedField",
        "name": "popularFeed",
        "plural": false,
        "selections": [
          {
            "concreteType": "PopularFeedItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v22/*: any*/),
                  (v23/*: any*/)
                ]
              }
            ]
          },
          (v24/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedPopularFeed",
        "kind": "LinkedField",
        "name": "popularFeed",
        "plural": false,
        "selections": [
          {
            "concreteType": "PopularFeedItem",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v7/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v7/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v22/*: any*/),
                  (v23/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          },
          (v24/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "701c47ab92ba720656167a68651cabf8",
    "id": "945e7480c8024c5838976cd3c3e16f1bc80c56650f328afd46dd6931baf9bf0f",
    "metadata": {},
    "name": "PopularFeedWithTimeGranularityStorageSnippetsQuery",
    "operationKind": "query",
    "text": "query PopularFeedWithTimeGranularityStorageSnippetsQuery($first:Int,$after:String,$timeGranularity:String=\"default\",$isRovoLLMEnabled:Boolean=false){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\")@include(if:$isRovoLLMEnabled){errorMessage,createdAt,objectData},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
  }
};
})();

(node as any).hash = "01929ccf73034c49133b68b9a80dd611";

export default node;
